import { TAdvertisersReportTableFilters } from '../../../models/types'

export const selectAdvertisersTableReportingFilters = ({
  reportingFilters: reportingAdvertisersTableFiltersState,
}: {
  reportingFilters: TAdvertisersReportTableFilters
}): TAdvertisersReportTableFilters => reportingAdvertisersTableFiltersState
